// 2026-04-24: Custom dialog system thay thế native window.confirm/alert/prompt
//
// Native browser dialogs xấu, không nhất quán giữa các browser, không match
// design của app, không hỗ trợ rich content. App tự design modal qua đây.
//
// Usage (imperative — gọi trong async function):
//   import { showConfirm, showAlert, showPrompt } from '../lib/dialogs.js';
//   const ok = await showConfirm({ message: 'Xoá?' });
//   const text = await showPrompt({ message: 'Nhập tên', defaultValue: 'A' });
//   await showAlert({ message: 'Xong rồi!' });
//
// DialogHost component (render modal) cần mount 1 lần ở App root.

import { create } from 'zustand';

export const useDialogStore = create((set) => ({
  current: null,  // null hoặc spec đang hiện
  set: (c) => set({ current: c }),
}));

function open(spec) {
  return new Promise((resolve) => {
    useDialogStore.getState().set({
      ...spec,
      resolve: (value) => {
        resolve(value);
        useDialogStore.getState().set(null);
      },
    });
  });
}

/**
 * @param {Object} opts
 * @param {string} opts.message - nội dung chính (required)
 * @param {string} [opts.title] - tiêu đề trên cùng
 * @param {string} [opts.confirmText='Đồng ý']
 * @param {string} [opts.cancelText='Huỷ']
 * @param {boolean} [opts.dangerous=false] - nút confirm màu đỏ (cho destructive action)
 * @returns {Promise<boolean>} true nếu user bấm confirm, false nếu huỷ/đóng
 */
export function showConfirm({
  message, title, confirmText = 'Đồng ý', cancelText = 'Huỷ', dangerous = false,
}) {
  return open({
    type: 'confirm', title, message, confirmText, cancelText, dangerous,
  });
}

/**
 * @param {Object} opts
 * @param {string} opts.message
 * @param {string} [opts.title]
 * @param {'info'|'success'|'warning'|'error'} [opts.variant='info']
 * @param {string} [opts.confirmText='Đã hiểu']
 * @returns {Promise<void>}
 */
export function showAlert({
  message, title, variant = 'info', confirmText = 'Đã hiểu',
}) {
  return open({
    type: 'alert', title, message, variant, confirmText,
  });
}

/**
 * @param {Object} opts
 * @param {string} opts.message - label/hint cho input
 * @param {string} [opts.title]
 * @param {string} [opts.defaultValue='']
 * @param {string} [opts.placeholder='']
 * @param {boolean} [opts.multiline=false] - dùng textarea thay input
 * @param {string} [opts.inputType='text'] - 'text' | 'password' | 'number'
 * @param {string} [opts.confirmText='Đồng ý']
 * @param {string} [opts.cancelText='Huỷ']
 * @returns {Promise<string|null>} chuỗi nếu confirm, null nếu huỷ
 */
export function showPrompt({
  message, title,
  defaultValue = '', placeholder = '',
  multiline = false, inputType = 'text',
  confirmText = 'Đồng ý', cancelText = 'Huỷ',
}) {
  return open({
    type: 'prompt', title, message,
    defaultValue, placeholder, multiline, inputType,
    confirmText, cancelText,
  });
}
